// Google Analytics event tracking utility

/**
 * Track a custom event
 * @param {string} eventName - Name of the event (e.g., 'button_click', 'course_view')
 * @param {object} eventParams - Additional parameters for the event
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
    console.log('GA Event tracked:', eventName, eventParams); // For debugging
  } else {
    console.warn('Google Analytics not loaded');
  }
};

/**
 * Track page view
 * @param {string} pageTitle - Title of the page
 * @param {string} pagePath - Path of the page
 */
export const trackPageView = (pageTitle, pagePath) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_title: pageTitle,
      page_path: pagePath,
    });
  }
};

/**
 * Track user interactions
 */
export const trackButtonClick = (buttonName, buttonLocation) => {
  trackEvent('button_click', {
    button_name: buttonName,
    button_location: buttonLocation,
  });
};

export const trackCourseView = (courseId, courseName, courseCategory) => {
  trackEvent('view_item', {
    item_id: courseId,
    item_name: courseName,
    item_category: courseCategory,
  });
};

export const trackCourseClick = (courseId, courseName, source) => {
  trackEvent('course_click', {
    course_id: courseId,
    course_name: courseName,
    source: source, // e.g., 'search_results', 'recommendations', 'category'
  });
};

export const trackSearch = (searchTerm, searchResults) => {
  trackEvent('search', {
    search_term: searchTerm,
    search_results: searchResults,
  });
};

export const trackBookmark = (action, itemId, itemName) => {
  trackEvent('bookmark_action', {
    action: action, // 'add' or 'remove'
    item_id: itemId,
    item_name: itemName,
  });
};

export const trackFormSubmit = (formName, formData = {}) => {
  trackEvent('form_submit', {
    form_name: formName,
    ...formData,
  });
};

export const trackVideoPlay = (videoId, videoName) => {
  trackEvent('video_play', {
    video_id: videoId,
    video_name: videoName,
  });
};

export const trackDownload = (fileName, fileType) => {
  trackEvent('file_download', {
    file_name: fileName,
    file_type: fileType,
  });
};

export const trackError = (errorMessage, errorLocation) => {
  trackEvent('error_occurred', {
    error_message: errorMessage,
    error_location: errorLocation,
  });
};

export const trackFilterApplied = (filterType, filterValue) => {
  trackEvent('filter_applied', {
    filter_type: filterType,
    filter_value: filterValue,
  });
};

export const trackNavigation = (navItem, navLocation) => {
  trackEvent('navigation', {
    nav_item: navItem,
    nav_location: navLocation,
  });
};

export const trackShare = (method, contentType, contentId) => {
  trackEvent('share', {
    method: method, // 'twitter', 'facebook', 'linkedin', etc.
    content_type: contentType,
    content_id: contentId,
  });
};

export const trackLogin = (method) => {
  trackEvent('login', {
    method: method, // 'email', 'google', 'facebook', etc.
  });
};

export const trackSignUp = (method) => {
  trackEvent('sign_up', {
    method: method,
  });
};
